export default __webpack_public_path__ + "static/media/apple_help_2.28990752.png";